import type { JssStyle } from 'jss';
import type { WebLegacyWidgetEntity } from '@web/types';
import type { ShopCartIconWidgetData } from '@web/widgets/shop-cart-icon/type/shop-cart-icon-widget.type';

import { ESize } from '@common/enums';

function previewIconSize(size: ESize): string {
    switch (size) {
        case ESize.S:
            return '40px';
        case ESize.M:
            return '48px';
        case ESize.L:
            return '56px';
        default:
            return '48px';
    }
}

export function getStyles({ data }: WebLegacyWidgetEntity<ShopCartIconWidgetData>): JssStyle {
    const cartIconSet = data;
    const cartIconStyle: JssStyle = {
        position: 'fixed',
        right: '3%',
        top: '3%',
        '& .cart-icon-wrapper': {
            borderRadius: `${cartIconSet.iconRounding}px`,
            background: cartIconSet.iconBgColor,
            color: cartIconSet.iconColor,
            height: previewIconSize(cartIconSet.iconSize),
            width: previewIconSize(cartIconSet.iconSize),
        },
        '& .icon-counter': {
            background: cartIconSet.iconCounterBgColor,
            color: cartIconSet.iconCounterColor,
        },
    };

    return {
        cartIconStyle,
    };
}
